import React from 'react';
import styled from 'styled-components';
import TableCell from './TableCell';
import MUITableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const StyledTableHead = styled(MUITableHead)``;

const StyledTableRow = styled(TableRow)``;

const StyledHeaderSpan = styled.span`
  display: inline-block;
  font-size: 16px;
  line-height: 1.2;
  font-family: 'Trade Gothic Bold Condensed';
  color: ${props => props.theme.tableText};
  text-transform: uppercase;
  white-space: nowrap;
  &.disable {
    color: ${props => props.theme.tableText};
  }
  &.header-text-wrap {
    display: block;
    width: 100%;
    white-space: normal;
    word-break: normal;
    overflow-wrap: normal;
  }
`;

const StyledTableCell = styled(TableCell)`
  background-color: transparent;
  border-bottom: 1px solid transparent;
  &&.MuiTableCell-head {
    padding-bottom: 4px;
    vertical-align: middle;
  }
`;

const StyledTableSortLabel = styled(TableSortLabel)`
  .MuiTableSortLabel-icon {
    color: ${props => props.theme.tableText};
  }
  &&&.MuiTableSortLabel-active .MuiTableSortLabel-icon {
    color: ${props => props.theme.subtleText};
  }
  &.sort-label-wrap {
    align-items: flex-start;
    text-align: left;
    white-space: normal;
    flex-wrap: wrap;
    max-width: 100%;
    .MuiTableSortLabel-icon {
      margin-top: 2px;
    }
  }
`;

function TableHead(props) {
  const {columns, order, orderBy, onRequestSort} = props;

  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  const columnStyle = column => {
    const style = {};
    if (column.width != null) {
      style.width = column.width;
    }
    if (column.minWidth != null) {
      style.minWidth = column.minWidth;
    }
    if (column.maxWidth != null) {
      style.maxWidth = column.maxWidth;
    }
    return Object.keys(style).length ? style : undefined;
  };

  return (
    <StyledTableHead>
      <StyledTableRow>
        {columns.map(column => {
          const headerWrap = Boolean(column.headerWrap);
          const headerSpanClass = headerWrap ? 'header-text-wrap' : '';
          const cellClass = `header-cell ${column.customClass || ''} ${
            headerWrap ? 'header-wrap' : ''
          }`.trim();
          return (
            <StyledTableCell
              key={column.id}
              variant="head"
              align={column.align}
              style={columnStyle(column)}
              sortDirection={orderBy === column.id ? order : false}
              className={cellClass}
            >
              {column.disableSort ? (
                <StyledHeaderSpan className={headerSpanClass}>{column.label}</StyledHeaderSpan>
              ) : (
                <StyledTableSortLabel
                  className={headerWrap ? 'sort-label-wrap' : undefined}
                  active={orderBy === column.id}
                  direction={orderBy === column.id ? order : 'asc'}
                  onClick={createSortHandler(column.id)}
                  IconComponent={ArrowDropDownIcon}
                >
                  <StyledHeaderSpan className={headerSpanClass}>{column.label}</StyledHeaderSpan>
                </StyledTableSortLabel>
              )}
            </StyledTableCell>
          );
        })}
      </StyledTableRow>
    </StyledTableHead>
  );
}

export default TableHead;
